// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1xpMj","info":"UpdateTermsInfo_info__244yB"};